import { render } from "./ticket.vue?vue&type=template&id=5c4843af&scoped=true"
import script from "./ticket.vue?vue&type=script&lang=js"
export * from "./ticket.vue?vue&type=script&lang=js"

import "./ticket.vue?vue&type=style&index=0&id=5c4843af&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5c4843af"

export default script